export interface Restaurant {
  restaurant_id: string;
  restaurant_parent_id: string;
  phone: string;
  restaurant_name: string;
  state: string;
  country: string;
  zipcode: string;
  address: string;
  account_id: string;
  catalog_status: string;
  created_date: string;
  [key: string]: any;
}

export interface MenuUploadCountResponse {
  response: {
    franchises: {
      data: Restaurant[];
      count: number;
    };
    menuImageUploadCount: number;
  };
}

export const analyticsService = {
  getMenuUploadCount: async (
    apiBaseUrl: string,
    accountId: string,
    startDate?: string,
    endDate?: string
  ): Promise<MenuUploadCountResponse> => {
    if (!accountId) {
      throw new Error('No account ID available');
    }

    // Build query parameters
    const params = new URLSearchParams();
    if (startDate) {
      params.append('start_date', startDate);
    }
    if (endDate) {
      params.append('end_date', endDate);
    }

    const queryString = params.toString();
    const endpoint = `/menuUploadCount${queryString ? `?${queryString}` : ''}`;

    console.log('🟣 analyticsService - Calling:', `${apiBaseUrl}${endpoint}`);

    // Only API-Key in headers
    const response = await fetch(`${apiBaseUrl}${endpoint}`, {
      method: 'GET',
      headers: {
        'API-Key': accountId,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch menu upload count');
    }

    const data = await response.json();
    console.log('🟣 analyticsService - Response:', data);
    return data;
  },

  getRestaurantMenuStatus: async (
    apiBaseUrl: string,
    apiKey: string,
    restaurantId: string
  ): Promise<any> => {
    if (!apiKey) {
      throw new Error('No API key available');
    }

    if (!restaurantId) {
      throw new Error('No restaurant ID available');
    }

    const endpoint = `/restaurantMenuStatus`;

    const response = await fetch(`${apiBaseUrl}${endpoint}`, {
      method: 'GET',
      headers: {
        'api-key': apiKey,
        'restaurant-id': restaurantId,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch restaurant menu status');
    }

    const data = await response.json();
    return data;
  },
};
